<template>
    <div>
        <div style="margin-top:50px;margin-bottom:20px;margin-left:50px;margin-right:50px;">
            <div style="float:left;text-align:left;">
                <span style="color:#606266;">用户姓名</span>
                <el-input v-model="search_name" placeholder="请输入用户姓名" style="margin-left:10px;width:180px;" clearable @keyup.native.enter="getGLYFUserInfo"></el-input>
                <span style="margin-left:20px;color:#606266;">角色</span>
                <el-select v-model="search_role" placeholder="请选择角色类型" style="margin-left:10px;width:180px;" clearable @change="getGLYFUserInfo">
                    <el-option label="专家" value="expert"></el-option>
                    <el-option label="普通用户" value="common"></el-option>
                </el-select>
            </div>
            <div style="text-align:right;">
                <el-button type="primary" icon="el-icon-search" size="mini" @click="getGLYFUserInfo">查询</el-button>
                <el-button size="mini" icon="el-icon-refresh" style="margin-left:10px;" @click="reset">重置</el-button>
            </div>
        </div>
        <div style="border-top:1px solid #ebeef5;margin-left:50px;margin-right:50px;"></div>
        <div style="margin-left:50px;margin-right:50px;margin-top:30px;">
            <div style="float:left;text-align:left;">
                <el-button type="primary" icon="el-icon-plus" size="mini" @click="create_user">创建用户</el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" style="margin-left:10px;" @click="batch_delete_users">批量删除</el-button>
            </div>
            <div style="text-align:right;">
                <el-button type="primary" icon="el-icon-edit-outline" size="mini" @click="batch_change_score">批量修改积分</el-button>
                <el-button icon="el-icon-upload2" size="mini" style="margin-left:10px;" @click="import_glyf_users">导入用户</el-button>
                <el-button icon="el-icon-download" size="mini" style="margin-left:10px;" @click="export_glyf_users">导出用户</el-button>
                <el-dialog title="上传文件" :visible.sync="dialogFormVisible" width="600px" :destroy-on-close="true" :close-on-click-modal="false" class="import_user_dialog">
                    <!-- 这里给子组件传递了getManaQues方法，供子组件调用 -->
                    <upload ref="upload_file" :getGLYFUserInfo="getGLYFUserInfo" task_id=0 style="text-align:center;"></upload>
                    <div style="margin-top:20px;text-align:center;">
                        <el-button @click="dialogCancel">取 消</el-button>
                        <el-button type="primary" @click="uploadFile">立即上传</el-button>
                    </div>
                </el-dialog>
            </div>
            <el-dialog
            title="批量修改积分"
            :visible.sync="dialogVisible_score"
            width="430px"
            class="change_score_dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @open="dialogVisible_score_open">
                <div style="text-align:left;">
                    <el-radio v-model="score_change_type" label="增加">增加</el-radio>
                    <el-radio v-model="score_change_type" label="扣除">扣除</el-radio>
                    <el-input v-model="score_value" placeholder="请输入整数积分值" style="width:220px;"></el-input>
                <div>
                <br>
                <el-input v-model="score_change_reason" type="textarea" :rows="3" placeholder="请填写变更事由"></el-input>
                <div style="margin-top:15px;text-align:center;">
                    <el-button type="primary" size="mini" @click="changeApprove">提交</el-button>
                    <el-button type="primary" size="mini" @click="cancel_change">取消</el-button>
                </div>
            </el-dialog>
        </div>
        <div style="margin-left:50px;margin-right:50px;margin-top:10px;">
            <el-table
            :data="user_info"
            style="width:100%"
            stripe
            border
            @selection-change="handleUserSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="name" label="姓名" min-width="6%"></el-table-column>
                <el-table-column prop="user_type" label="用户类型" min-width="7%">
                    <template slot-scope="scope">
                        <span v-if="scope.row.user_type=='common'">普通用户</span>
                        <span v-else-if="scope.row.user_type=='guest'">游客</span>
                        <span v-else-if="scope.row.user_type=='expert'">专家</span>
                    </template>
                </el-table-column>
                <el-table-column prop="tel_num" label="手机号码" min-width="10%"></el-table-column>
                <el-table-column prop="email" label="邮箱" min-width="15%"></el-table-column>
                <el-table-column prop="company" label="公司" min-width="11%"></el-table-column>
                <el-table-column prop="permit_count" label="权限数" min-width="6%"></el-table-column>
                <el-table-column prop="question_count" label="提问数" min-width="6%">
                    <!-- <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="font-weight:bold;"
                        @click="show_details(scope.row.id, 'question_count')">{{ scope.row.question_count }}</el-button>
                    </template> -->
                </el-table-column>
                <!-- <el-table-column prop="answer_count" label="回答数" min-width="6%"> -->
                    <!-- <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="font-weight:bold;"
                        @click="show_details(scope.row.id, 'answer_count')">{{ scope.row.answer_count }}</el-button>
                    </template> -->
                <!-- </el-table-column> -->
                <el-table-column prop="favorite_count" label="收藏数" min-width="6%">
                    <!-- <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="font-weight:bold;"
                        @click="show_details(scope.row.id, 'favorite_count')">{{ scope.row.favorite_count }}</el-button>
                    </template> -->
                </el-table-column>
                <el-table-column prop="points" label="积分" min-width="5%">
                    <!-- <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="font-weight:bold;"
                        @click="show_details(scope.row.id, 'points')">{{ scope.row.points }}</el-button>
                    </template> -->
                </el-table-column>
                <el-table-column prop="operations" label="操作" min-width="12%">
                    <template slot-scope="scope">
                        <el-button
                        type="text"
                        style="font-weight:bold;"
                        @click="handlePermit(scope.row.id)">权限</el-button>
                        <el-button
                        type="text"
                        style="color:#E6A23C;font-weight:bold;"
                        @click="handleEdit(scope.row.id)">编辑</el-button>
                        <el-button
                        type="text"
                        style="color:#F56C6C;font-weight:bold;"
                        @click="handleDelete(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top:10px;" v-if="user_info.length > 0">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageinfo.current"
                    :page-sizes="pageinfo.page_sizes"
                    :page-size="pageinfo.page_size"
                    layout="total, sizes, prev, pager, next"
                    :total="pageinfo.count">
                </el-pagination>
            </div>
            <el-dialog
            :visible.sync="dialogVisible"
            :fullscreen="true"
            :show-close="false"
            custom-class="fullscreen-dialog"
            @open="handleDialogOpen"
            :close-on-click-modal="false"
            :close-on-press-escape="false">
            <template #title>
                <div class="dialog-header">
                <span>{{ dialog_title }}</span>
                <el-button
                    class="close-btn"
                    icon="el-icon-close"
                    @click="dialogVisible = false"
                ></el-button>
                </div>
            </template>

            <!-- 弹窗内容 -->
            <div class="dialog-content">
                <!-- 这里放你的具体内容 -->
                <div class="ql-editor" style="margin-left:50px;margin-right:50px;margin-top:10px;" v-if="dialog_show_type=='painspot_permit'">
                    <el-table
                    ref="multipleTable"
                    :data="details_info"
                    row-key="id"
                    style="width:100%"
                    stripe
                    border
                    @selection-change="handleSelectionChange">
                        <el-table-column type="selection" min-width="5%" v-if="dialog_title=='配置用户痛点查看权限'"></el-table-column>
                        <el-table-column type="index"></el-table-column>
                        <el-table-column :key="index" v-for="(col, index) in details_columns" :prop="col.name" :label="col.label" :min-width="col.min_width"></el-table-column>
                    </el-table>
                    <el-button type="primary" @click="savePainSpotConfig" v-if="dialog_title=='配置用户痛点查看权限'" style="margin-top:30px;">保存</el-button>
                </div>
                <div class="ql-editor" v-else-if="dialog_show_type=='create_user'">
                    <el-form :model="form" label-width="120px" label-position="left" style="width:350px;margin-left:50px;margin-top:20px;">
                        <el-form-item label="邮箱名">
                            <el-input v-model="form.email"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="昵称">
                            <el-input v-model="form.nick_name"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <template slot="label">
                                <span style="color:#F56C6C;font-weight:bold;">*</span><span>手机号码</span>
                            </template>
                            <el-input v-model="form.tel_num"></el-input>
                        </el-form-item>
                        <el-form-item label="用户类型">
                            <el-radio v-model="form.user_type" label="common">普通用户</el-radio>
                            <el-radio v-model="form.user_type" label="expert">专家</el-radio>
                        </el-form-item>
                        <el-form-item label="履历公司" v-show="form.user_type=='expert'">
                            <el-input v-model="form.company"></el-input>
                        </el-form-item>
                        <el-form-item label="职位" v-show="form.user_type=='expert'">
                            <el-input v-model="form.position"></el-input>
                        </el-form-item>
                        <el-form-item label="擅长领域" v-show="form.user_type=='expert'">
                            <el-input v-model="form.fields" type="textarea" autosize></el-input>
                        </el-form-item>
                        <el-form-item label="擅长行业" v-show="form.user_type=='expert'">
                            <el-input v-model="form.industries" type="textarea" autosize></el-input>
                        </el-form-item>
                        <el-form-item label="资费标准" v-show="form.user_type=='expert'">
                            <el-input v-model="form.tariff_standard" type="textarea" autosize></el-input>
                        </el-form-item>
                        <div style="padding-right:100px; margin-top:20px;">
                            <el-button type="primary" @click="commit_user_create">创建</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="ql-editor" v-else-if="dialog_show_type=='count_details'">
                    <el-table
                    :data="details_info"
                    style="width:100%"
                    stripe
                    border>
                        <el-table-column type="index"></el-table-column>
                        <el-table-column :key="index" v-for="(col, index) in details_columns" :prop="col.name" :label="col.label" :min-width="col.min_width"></el-table-column>
                    </el-table>
                </div>
                <div class="ql-editor" v-else>
                    <el-form :model="form_mod" label-width="120px" label-position="left" style="width:350px;margin-left:50px;margin-top:20px;">
                        <el-form-item label="邮箱名">
                            <el-input v-model="form_mod.email" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input v-model="form_mod.name"></el-input>
                        </el-form-item>
                        <el-form-item label="昵称">
                            <el-input v-model="form_mod.nick_name"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <template slot="label">
                                <span style="color:#F56C6C;font-weight:bold;">*</span><span>手机号码</span>
                            </template>
                            <el-input v-model="form_mod.tel_num"></el-input>
                        </el-form-item>
                        <el-form-item label="用户类型">
                            <el-radio v-model="form_mod.user_type" label="common">普通用户</el-radio>
                            <el-radio v-model="form_mod.user_type" label="expert">专家</el-radio>
                        </el-form-item>
                        <el-form-item label="履历公司" v-show="form_mod.user_type=='expert'">
                            <el-input v-model="form_mod.company"></el-input>
                        </el-form-item>
                        <el-form-item label="职位" v-show="form_mod.user_type=='expert'">
                            <el-input v-model="form_mod.position"></el-input>
                        </el-form-item>
                        <el-form-item label="擅长领域" v-show="form_mod.user_type=='expert'">
                            <el-input v-model="form_mod.fields" type="textarea" autosize></el-input>
                        </el-form-item>
                        <el-form-item label="擅长行业" v-show="form_mod.user_type=='expert'">
                            <el-input v-model="form_mod.industries" type="textarea" autosize></el-input>
                        </el-form-item>
                        <el-form-item label="资费标准" v-show="form_mod.user_type=='expert'">
                            <el-input v-model="form_mod.tariff_standard" type="textarea" autosize></el-input>
                        </el-form-item>
                        <div style="padding-right:100px; margin-top:20px;">
                            <el-button type="primary" @click="commit_user_modify">提交</el-button>
                            <el-button @click="gene_expert_link" v-if="form_mod.user_type=='expert'">专家链接</el-button>
                            <el-button type="danger" @click="reset_passwd">重置密码</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
import upload from "../UpLoad.vue";

export default {
    created() {
        this.getGLYFUserInfo();
    },
    data() {
        return {
            dialog_title: '',
            dialog_show_type: '',
            dialogVisible: false,
            dialogVisible_score: false,
            dialogFormVisible: false,
            search_name: '',
            search_role: '',
            user_info: [],
            details_info: [],
            details_columns: [],
            selectedRows: [],
            selectedUserRows: [],
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 20,
                page_sizes: [1, 10, 20, 50, 100],
            },
            form: {'user_type': 'common'},
            form_mod: {},
            config_user_id: null,
            score_change_type: '增加',
            score_value: '',
            score_change_reason: '',
            download_file: {
                file_name: 'glyf_users.xlsx',
            },
        }
    },
    components: {
        upload,
    },
    methods: {
        reset_passwd() {
            if(this.form_mod.id){
                this.$confirm("确认重置该用户的密码么？", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    let params;
                    params = {
                        user_id: this.form_mod.id,
                    }
                    getdata.getListP("resetGLYFUserPasswd", params)
                        .then(resp => {
                            if(resp.data.code == 200){
                                this.$message({
                                    message: "密码重置成功！重置后的密码为该用户的邮箱地址",
                                    type: "success",
                                })
                            }else{
                                this.$message({
                                    message: "密码重置失败！",
                                    type: "error",
                                    duration: 6000,
                                    // showClose: true,
                                })
                            }
                            // loading.close();
                        })
                        .catch(() => {
                            this.$message({
                                message: "用户删除失败！",
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        });
                }).catch(() => {
                    
                })
            }else{
                this.$alert('重置失败！', '错误', {
                    confirmButtonText: '确定',
                });
            }
        },
        gene_expert_link() {
            if(this.form_mod.id){
                this.$alert('在痛点编辑页面添加专家页面链接时，直接粘贴此内容即可：' + 'http://www.sanwuguanli.com/glyf/expert?id=' + this.form_mod.id, '专家页面链接', {
                    confirmButtonText: '确定',
                });
            }else{
                this.$alert('获取失败！', '错误', {
                    confirmButtonText: '确定',
                });
            }
        },
        import_glyf_users() {
            this.dialogFormVisible = true;
        },
        dialogCancel() {
            this.dialogFormVisible = false;
        },
        uploadFile() {
            // 调用子组件的上传方法
            this.$refs.upload_file.uploadFile('importGLYFUsers');
            this.dialogFormVisible = false;
            // 这里不能直接使用getManaQues()方法加载已导入的问卷，得在子组件中调用父组件的该方法完成加载
            // this.getManaQues();
        },
        export_glyf_users() {
            postdata.downloadFiles("exportGLYFUsers", JSON.stringify(this.download_file))
            .then(resp => {               
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        dialogVisible_score_open() {
            this.score_change_type = '增加';
            this.score_value = '';
            this.score_change_reason = '';
        },
        changeApprove() {
            var selectedIds = [];
            // if(this.selectedUserRows.length==0){
            //     this.$message({
            //     message: '未选择用户！',
            //     type: 'error',
            //     duration: 2000,
            //     })
            //     return;
            // }else{
                // var row;
            for(var row in this.selectedUserRows){
                selectedIds.push(this.selectedUserRows[row]['id']);
            }
                // console.log(selectedIds);
            // }
            let params;
            params = {
                'selectedIds': selectedIds,
                'change_type': this.score_change_type,
                'value': this.score_value,
                'reason': this.score_change_reason,
            }           
            getdata.getListP("batchChangeUserScore", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: 'success',
                    }) 
                    this.getGLYFUserInfo();
                    this.dialogVisible_score = false;               
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: 'error',
                        duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        cancel_change() {
            this.dialogVisible_score = false;
        },
        batch_change_score() {
            if(this.selectedUserRows.length==0){
                this.$message({
                message: '未选择用户！',
                type: 'error',
                duration: 2000,
                })
                return;
            }else{
                this.dialogVisible_score = true;
            }          
        },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            this.getGLYFUserInfo();
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            this.getGLYFUserInfo();
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleDelete(id) {
            this.$confirm("确认删除该用户么？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params;
                params = {
                    'user_id': id,
                }           
                getdata.getListP("deleteGLYFSingleUser", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: resp.data.message,
                            type: 'success',
                        }) 
                        this.getGLYFUserInfo();               
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: 'error',
                            duration: 6000,
                        })
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }).catch(() => {
                
            })
        },
        batch_delete_users() {
            var selectedIds = [];
            if(this.selectedUserRows.length==0){
                this.$message({
                message: '未选择用户！',
                type: 'error',
                duration: 2000,
                })
                return;
            }else{
                // var row;
                for(var row in this.selectedUserRows){
                    selectedIds.push(this.selectedUserRows[row]['id']);
                }
                // console.log(selectedIds);
            }
            this.$confirm("确认批量删除这些用户么？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params;
                params = {
                    'selectedIds': selectedIds,
                }           
                getdata.getListP("batchDeleteGLYFUsers", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: resp.data.message,
                            type: 'success',
                        }) 
                        this.getGLYFUserInfo();               
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: 'error',
                            duration: 6000,
                        })
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            }).catch(() => {
                
            })
        },
        handleUserSelectionChange(val) {
            this.selectedUserRows = val;
        },
        reset() {
            this.search_name = '';
            this.search_role = '';
            this.getGLYFUserInfo();
        },
        getGLYFUserInfo() {
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                name: this.search_name,
                user_type: this.search_role
            }
            getdata.getListP("getGLYFUserInfos", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.user_info = resp.data.data;
                    this.pageinfo.count = resp.data.count;          
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        show_details(uid, show_type) {
            this.dialog_show_type = 'count_details';
            if(show_type=='question_count'){
                this.dialog_title = '提问明细';
                this.details_columns = [
                    {'name': 'datetime', 'label': '提问日期', 'min_width': '25%'}, 
                    {'name': 'title', 'label': '提问问题', 'min_width': '50%'}, 
                    {'name': 'status', 'label': '状态', 'min_width': '25%'}]
            }else if(show_type=='answer_count'){
                this.dialog_title = '回答明细';
                this.details_columns = [
                    {'name': 'datetime', 'label': '回答日期', 'min_width': '25%'}, 
                    {'name': 'title', 'label': '回答问题', 'min_width': '50%'}, 
                    {'name': 'status', 'label': '状态', 'min_width': '25%'}]
            }else if(show_type=='favorite_count'){
                this.dialog_title = '收藏明细';
                this.details_columns = [
                    {'name': 'datetime', 'label': '收藏日期', 'min_width': '40%'}, 
                    {'name': 'title', 'label': '收藏问题', 'min_width': '60%'}]
            }else if(show_type=='score'){
                this.dialog_title = '积分明细';
                this.details_columns = [
                    {'name': 'datetime', 'label': '积分日期', 'min_width': '20%'}, 
                    {'name': 'reason', 'label': '积分原因', 'min_width': '40%'}, 
                    {'name': 'change', 'label': '积分变动', 'min_width': '20%'}, 
                    {'name': 'score_after', 'label': '变动后积分', 'min_width': '20%'}]
            }
            this.dialogVisible = true;
        },
        handlePermit(uid) {
            this.dialog_show_type = 'painspot_permit';
            this.dialog_title = '配置用户痛点查看权限';
            this.config_user_id = uid;
            this.details_columns = [
                {'name': 'classification', 'label': '一级目录', 'min_width': '15%'},
                {'name': 'sub_class', 'label': '二级目录', 'min_width': '15%'},
                {'name': 'title', 'label': '痛点名称', 'min_width': '50%'}, 
                {'name': 'update_time', 'label': '更新日期', 'min_width': '15%'}]
            this.dialogVisible = true;
        },
        create_user() {
            this.dialog_show_type = 'create_user';
            this.dialog_title = '创建新用户';
            this.dialogVisible = true;
        },
        handleEdit(id) {
            this.dialog_show_type = 'edit_user';
            this.dialog_title = '编辑用户信息';
            this.getGLYFUserInfoDetails(id);
        },
        getGLYFUserInfoDetails(id) {
            let params;
            params = {
                'user_id': id,
            }           
            getdata.getListP("getGLYFUserInfoDetails", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.form_mod = resp.data.data;
                    this.dialogVisible = true;                
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: 'error',
                        duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        commit_user_modify() {
            if(!this.form_mod.tel_num){
                this.$message({
                message: '请配置手机号码！',
                type: 'error',
                duration: 6000,
                })
                return;
            }
            postdata.postList("modifyGLYFUser", JSON.stringify(this.form_mod))
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: 'success',
                    })
                    this.getGLYFUserInfo();
                    this.dialogVisible = false; 
                    this.form_mod = {};                 
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: 'error',
                        duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        commit_user_create() {
            if(!this.form.email){
                this.$message({
                message: '请配置邮箱名！',
                type: 'error',
                duration: 6000,
                })
                return;
            }else if(!this.form.tel_num){
                this.$message({
                message: '请配置手机号码！',
                type: 'error',
                duration: 6000,
                })
                return;
            }
            postdata.postList("createGLYFUser", JSON.stringify(this.form))
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: 'success',
                    })
                    this.getGLYFUserInfo();
                    this.dialogVisible = false; 
                    this.form = {};                 
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: 'error',
                        duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        handleSelectionChange(val) {
            this.selectedRows = val;
            // console.log(val);
        },
        savePainSpotConfig() {
            var selectedIds = [];
            if(this.selectedRows.length==0){
                this.$message({
                message: '未选择痛点！',
                type: 'error',
                duration: 2000,
                })
                return;
            }else{
                // var row;
                for(var row in this.selectedRows){
                    selectedIds.push(this.selectedRows[row]['id']);
                }
                // console.log(selectedIds);
            }
            let params;
            params = {
                'selectedIds': selectedIds,
                'user_id': this.config_user_id,
            }           
            getdata.getListP("savePainSpotPermitConfig", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: 'success',
                    }) 
                    this.getGLYFUserInfo(); 
                    this.dialogVisible = false;                
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: 'error',
                        duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        handleDialogOpen() {
            if(this.dialog_title=='配置用户痛点查看权限'){
                this.getUserPainSpotPermit();
            }
        },
        getUserPainSpotPermit() {
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                id: this.config_user_id,
            }           
            getdata.getListP("getUserPainSpotPermit", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.details_info = resp.data.data;
                    var selectedIds = resp.data.selected_data;
                    // this.selectedRows = resp.data.selected_data;
                    this.$nextTick(() => {
                        if (!selectedIds.length) return;
                        
                        // 遍历表格数据找出需要选中的行
                        this.details_info.forEach(row => {
                        if (selectedIds.includes(row.id)) {
                            // 调用表格方法设置选中
                            this.$refs.multipleTable.toggleRowSelection(row, true);
                        }
                        });
                    });                  
                }else{
                    this.details_info = [];
                    this.$message({
                        message: resp.data.message,
                        type: 'error',
                        duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    }
}
</script>

<style scoped>
::v-deep .el-input__inner {
    height: 28px;
    /* line-height: 28px; */
}
::v-deep .el-input__icon {
    line-height: 28px;
}
::v-deep .el-select .el-input .el-select__caret {
    line-height: 28px;
}
::v-deep .el-table th {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
::v-deep .el-table__row td {
    line-height: 30px;
    padding: 0; /* 可选：减少默认内边距 */
}
::v-deep .el-form-item {
    margin-bottom: 0px;
}
.change_score_dialog /deep/ .el-dialog__header {
    text-align: left;
}
.import_user_dialog /deep/ .el-dialog__header {
    text-align: left;
}
</style>

